/**
 * Client-supplied brand banner, used once on the homepage as a full-bleed band.
 *
 * The artwork's bottom cream wave measures #f3f0e6 against --color-cream
 * #f5efe6, so the band dissolves into the section below it while its green top
 * edge reads as a wave rising out of the page. That only works on a cream
 * background, full bleed, with no border and no rounding.
 *
 * Aspect ratio is pinned per breakpoint in CSS rather than relying on the
 * img's width/height attributes: <source media> swaps the intrinsic size out
 * from under them, so the box has to be reserved in CSS to avoid layout shift.
 * Each asset's real ratio matches its breakpoint exactly, so object-cover
 * never actually crops. Lazy because the band always sits below the fold.
 */

export function BrandBanner() {
  return (
    <section className="bg-[var(--color-cream)]">
      <picture>
        <source
          media="(max-width: 639px)"
          srcSet="/brand/yl-banner-mobile-760.webp"
          type="image/webp"
        />
        <source
          media="(max-width: 639px)"
          srcSet="/brand/yl-banner-mobile-760.jpg"
        />
        <source
          type="image/webp"
          srcSet="/brand/yl-banner-992.webp 992w, /brand/yl-banner-1600.webp 1600w"
          sizes="100vw"
        />
        <img
          src="/brand/yl-banner-1600.jpg"
          srcSet="/brand/yl-banner-992.jpg 992w, /brand/yl-banner-1600.jpg 1600w"
          sizes="100vw"
          alt="Your Lane Coaching. Clarity. Confidence. Your journey."
          width={1600}
          height={640}
          loading="lazy"
          decoding="async"
          className="block w-full object-cover aspect-[1000/793] sm:aspect-[1983/793]"
        />
      </picture>
    </section>
  );
}
